// export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
// export const TIMEOUT_SEC = 10;
// export const RES_PER_PAGE = 10;
// export const KEY = '<YOUR_KEY>';
// export const MODAL_CLOSE_SEC = 2.5;

export const DEFAULT_ANIMATION = `fade-in-bottom`;
export const SECONDARY_ANIMATION = `flip-in-hor-top`;
export const TERTIARY_ANIMATION = `slide-in-bottom`;
export const WOBBLE_ANIMATION = `wobble-hor-bottom`;
export const DEFAULT_ANIMATION_DELAY = 175;
export const BIG_ANIMATION_DELAY = 1500;
export const MEDIA_QUERY_900_PX = window.matchMedia('(max-width: 900px)');
export const MEDIA_QUERY_600_PX = window.matchMedia('(min-width: 600px)');
export const MEDIA_QUERY_450_PX = window.matchMedia('(max-width: 450px)');
export const MEDIA_QUERY_350_PX = window.matchMedia('(max-width: 350px)');
